export const WEB_SAFE_FONTS = {
    arial: {
        displayName: 'Arial',
        fontFamily: 'arial',
        cdnName: '',
        genericFamily: 'sans-serif',
        provider: 'web-safe',
        characterSets: [],
        fallbacks: '',
        spriteIndex: 21,
        supportedInHtmlEmails: true,
        key: 'arial',
        cssFontFamily: 'arial,sans-serif',
        normalizedCss: 'arial,sans-serif',
    },
    'comic sans': {
        displayName: 'Comic Sans',
        fontFamily: 'comic sans',
        cdnName: '',
        genericFamily: 'sans-serif',
        provider: 'web-safe',
        characterSets: [],
        fallbacks: 'comic sans ms,chalkboard,chalkboardse-regular,marker felt',
        spriteIndex: 27,
        supportedInHtmlEmails: true,
        key: 'comic sans',
        cssFontFamily: '"comic sans","comic sans ms",chalkboard,chalkboardse-regular,"marker felt",sans-serif',
        normalizedCss: 'comicsans,comicsansms,chalkboard,chalkboardse-regular,markerfelt,sans-serif',
    },
    courier: {
        displayName: 'Courier',
        fontFamily: 'courier',
        cdnName: '',
        genericFamily: 'monospace',
        provider: 'web-safe',
        characterSets: [],
        fallbacks: '',
        spriteIndex: 26,
        supportedInHtmlEmails: true,
        key: 'courier',
        cssFontFamily: 'courier,monospace',
        normalizedCss: 'courier,monospace',
    },
    georgia: {
        displayName: 'Georgia',
        fontFamily: 'georgia',
        cdnName: '',
        genericFamily: 'serif',
        provider: 'web-safe',
        characterSets: [],
        fallbacks: '',
        spriteIndex: 24,
        supportedInHtmlEmails: true,
        key: 'georgia',
        cssFontFamily: 'georgia,serif',
        normalizedCss: 'georgia,serif',
    },
    helvetica: {
        displayName: 'Helvetica',
        fontFamily: 'helvetica',
        cdnName: '',
        genericFamily: 'sans-serif',
        provider: 'web-safe',
        characterSets: [],
        fallbacks: '',
        spriteIndex: 20,
        supportedInHtmlEmails: true,
        key: 'helvetica',
        cssFontFamily: 'helvetica,sans-serif',
        normalizedCss: 'helvetica,sans-serif',
    },
    tahoma: {
        displayName: 'Tahoma',
        fontFamily: 'tahoma',
        cdnName: '',
        genericFamily: 'sans-serif',
        provider: 'web-safe',
        characterSets: [],
        fallbacks: '',
        spriteIndex: 28,
        supportedInHtmlEmails: true,
        key: 'tahoma',
        cssFontFamily: 'tahoma,sans-serif',
        normalizedCss: 'tahoma,sans-serif',
    },
    'times new roman': {
        displayName: 'Times New Roman',
        fontFamily: 'times new roman',
        cdnName: '',
        genericFamily: 'serif',
        provider: 'web-safe',
        characterSets: [],
        fallbacks: '',
        spriteIndex: 25,
        supportedInHtmlEmails: true,
        key: 'times new roman',
        cssFontFamily: '"times new roman",serif',
        normalizedCss: 'timesnewroman,serif',
    },
    'trebuchet ms': {
        displayName: 'Trebuchet MS',
        fontFamily: 'trebuchet ms',
        cdnName: '',
        genericFamily: 'sans-serif',
        provider: 'web-safe',
        characterSets: [],
        fallbacks: '',
        spriteIndex: 23,
        supportedInHtmlEmails: true,
        key: 'trebuchet ms',
        cssFontFamily: '"trebuchet ms",sans-serif',
        normalizedCss: 'trebuchetms,sans-serif',
    },
    verdana: {
        displayName: 'Verdana',
        fontFamily: 'verdana',
        cdnName: '',
        genericFamily: 'sans-serif',
        provider: 'web-safe',
        characterSets: [],
        fallbacks: '',
        spriteIndex: 22,
        supportedInHtmlEmails: true,
        key: 'verdana',
        cssFontFamily: 'verdana,sans-serif',
        normalizedCss: 'verdana,sans-serif',
    },
};
export const CUSTOM_FONTS = {
    'amatic sc': {
        displayName: 'Amatic SC',
        fontFamily: 'amatic sc',
        cdnName: 'AmaticSC',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin', 'latin-ext'],
        fallbacks: '',
        spriteIndex: 112,
        supportedInHtmlEmails: true,
        key: 'amatic sc',
        cssFontFamily: '"amatic sc",cursive',
        normalizedCss: 'amaticsc,cursive',
    },
    'bodonistd poster': {
        displayName: 'Bodoni Poster',
        fontFamily: 'bodonistd poster',
        cdnName: '',
        genericFamily: 'serif',
        provider: 'system',
        characterSets: [
            'latin',
            'latin-ext',
            'greek',
            'greek-ext',
            'cyrillic',
            'cyrillic-ext',
        ],
        fallbacks: '',
        spriteIndex: 103,
        supportedInHtmlEmails: false,
        key: 'bodonistd poster',
        cssFontFamily: '"bodonistd poster",serif',
        normalizedCss: 'bodonistdposter,serif',
    },
    cookie: {
        displayName: 'Cookie',
        fontFamily: 'cookie',
        cdnName: 'Cookie',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin'],
        fallbacks: '',
        spriteIndex: 115,
        supportedInHtmlEmails: true,
        key: 'cookie',
        cssFontFamily: 'cookie,cursive',
        normalizedCss: 'cookie,cursive',
    },
    'courier new': {
        displayName: 'Courier New',
        fontFamily: 'courier new',
        cdnName: '',
        genericFamily: 'monospace',
        provider: 'system',
        characterSets: [],
        fallbacks: '',
        spriteIndex: 100,
        supportedInHtmlEmails: false,
        key: 'courier new',
        cssFontFamily: '"courier new",monospace',
        normalizedCss: 'couriernew,monospace',
    },
    'din next lt pro light': {
        displayName: 'DIN Next LT Pro Light',
        fontFamily: 'dinnextlight',
        cdnName: '',
        genericFamily: 'sans-serif',
        provider: 'system',
        characterSets: ['latin'],
        fallbacks: '',
        spriteIndex: 102,
        supportedInHtmlEmails: false,
        key: 'din next lt pro light',
        cssFontFamily: 'dinnextlight,sans-serif',
        normalizedCss: 'dinnextlight,sans-serif',
    },
    'dancing script': {
        displayName: 'Dancing Script',
        fontFamily: 'dancing script',
        cdnName: 'DancingScript',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin'],
        fallbacks: '',
        spriteIndex: 118,
        supportedInHtmlEmails: true,
        key: 'dancing script',
        cssFontFamily: '"dancing script",cursive',
        normalizedCss: 'dancingscript,cursive',
    },
    'droid serif': {
        displayName: 'Droid Serif',
        fontFamily: 'droid serif',
        cdnName: 'DroidSerif',
        genericFamily: 'serif',
        provider: 'google',
        characterSets: ['latin'],
        fallbacks: '',
        spriteIndex: 123,
        supportedInHtmlEmails: false,
        key: 'droid serif',
        cssFontFamily: '"droid serif",serif',
        normalizedCss: 'droidserif,serif',
    },
    'fjalla one': {
        displayName: 'Fjalla One',
        fontFamily: 'fjalla one',
        cdnName: 'FjallaOne',
        genericFamily: 'sans-serif',
        provider: 'google',
        characterSets: ['latin', 'latin-ext'],
        fallbacks: '',
        spriteIndex: 113,
        supportedInHtmlEmails: true,
        key: 'fjalla one',
        cssFontFamily: '"fjalla one",sans-serif',
        normalizedCss: 'fjallaone,sans-serif',
    },
    'fredericka the great': {
        displayName: 'Fredericka the Great',
        fontFamily: 'fredericka the great',
        cdnName: 'FrederickatheGreat',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin'],
        fallbacks: '',
        spriteIndex: 125,
        supportedInHtmlEmails: true,
        key: 'fredericka the great',
        cssFontFamily: '"fredericka the great",cursive',
        normalizedCss: 'frederickathegreat,cursive',
    },
    areciboitcstd: {
        displayName: 'ITC Arecibo',
        fontFamily: 'areciboitcstd',
        cdnName: '',
        genericFamily: 'serif',
        provider: 'system',
        characterSets: ['latin'],
        fallbacks: '',
        spriteIndex: 104,
        supportedInHtmlEmails: false,
        key: 'areciboitcstd',
        cssFontFamily: 'areciboitcstd,serif',
        normalizedCss: 'areciboitcstd,serif',
    },
    jura: {
        displayName: 'Jura',
        fontFamily: 'jura',
        cdnName: 'Jura',
        genericFamily: 'sans-serif',
        provider: 'google',
        characterSets: ['latin', 'latin-ext', 'greek', 'cyrillic', 'cyrillic-ext'],
        fallbacks: '',
        spriteIndex: 121,
        supportedInHtmlEmails: true,
        key: 'jura',
        cssFontFamily: 'jura,sans-serif',
        normalizedCss: 'jura,sans-serif',
    },
    Lato: {
        displayName: 'Lato',
        fontFamily: 'Lato',
        cdnName: 'Lato',
        genericFamily: 'sans-serif',
        provider: 'google',
        characterSets: ['latin', 'latin-ext'],
        fallbacks: '',
        spriteIndex: 126,
        supportedInHtmlEmails: true,
        key: 'Lato',
        cssFontFamily: 'Lato,sans-serif',
        normalizedCss: 'lato,sans-serif',
    },
    lobster: {
        displayName: 'Lobster',
        fontFamily: 'lobster',
        cdnName: 'Lobster',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin', 'latin-ext', 'vietnamese', 'cyrillic'],
        fallbacks: '',
        spriteIndex: 114,
        supportedInHtmlEmails: true,
        key: 'lobster',
        cssFontFamily: 'lobster,cursive',
        normalizedCss: 'lobster,cursive',
    },
    montserrat: {
        displayName: 'Montserrat',
        fontFamily: 'montserrat',
        cdnName: 'Montserrat',
        genericFamily: 'sans-serif',
        provider: 'google',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        fallbacks: '',
        spriteIndex: 109,
        supportedInHtmlEmails: true,
        key: 'montserrat',
        cssFontFamily: 'montserrat,sans-serif',
        normalizedCss: 'montserrat,sans-serif',
    },
    'niconne regular': {
        displayName: 'Niconne',
        fontFamily: 'niconne-regular',
        cdnName: '',
        genericFamily: 'cursive',
        provider: 'system',
        characterSets: ['latin', 'latin-ext'],
        fallbacks: '',
        spriteIndex: 101,
        supportedInHtmlEmails: true,
        key: 'niconne regular',
        cssFontFamily: 'niconne-regular,cursive',
        normalizedCss: 'niconne-regular,cursive',
    },
    'nixie one': {
        displayName: 'Nixie One',
        fontFamily: 'nixie one',
        cdnName: 'NixieOne',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin'],
        fallbacks: '',
        spriteIndex: 124,
        supportedInHtmlEmails: true,
        key: 'nixie one',
        cssFontFamily: '"nixie one",cursive',
        normalizedCss: 'nixieone,cursive',
    },
    'open sans': {
        displayName: 'Open Sans',
        fontFamily: 'open sans',
        cdnName: 'OpenSans',
        genericFamily: 'sans-serif',
        provider: 'google',
        characterSets: [
            'latin',
            'latin-ext',
            'greek',
            'greek-ext',
            'vietnamese',
            'cyrillic',
            'cyrillic-ext',
        ],
        fallbacks: '',
        spriteIndex: 119,
        supportedInHtmlEmails: true,
        key: 'open sans',
        cssFontFamily: '"open sans",sans-serif',
        normalizedCss: 'opensans,sans-serif',
    },
    'open sans condensed': {
        displayName: 'Open Sans Condensed',
        fontFamily: 'open sans condensed',
        cdnName: 'OpenSansCondensed',
        genericFamily: 'sans-serif',
        provider: 'google',
        characterSets: [
            'latin',
            'latin-ext',
            'greek',
            'greek-ext',
            'vietnamese',
            'cyrillic',
            'cyrillic-ext',
        ],
        fallbacks: '',
        spriteIndex: 120,
        supportedInHtmlEmails: true,
        key: 'open sans condensed',
        cssFontFamily: '"open sans condensed",sans-serif',
        normalizedCss: 'opensanscondensed,sans-serif',
    },
    overlock: {
        displayName: 'Overlock',
        fontFamily: 'overlock',
        cdnName: 'Overlock',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin', 'latin-ext'],
        fallbacks: '',
        spriteIndex: 117,
        supportedInHtmlEmails: true,
        key: 'overlock',
        cssFontFamily: 'overlock,cursive',
        normalizedCss: 'overlock,cursive',
    },
    pacifico: {
        displayName: 'Pacifico',
        fontFamily: 'pacifico',
        cdnName: 'Pacifico',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin'],
        fallbacks: '',
        spriteIndex: 116,
        supportedInHtmlEmails: true,
        key: 'pacifico',
        cssFontFamily: 'pacifico,cursive',
        normalizedCss: 'pacifico,cursive',
    },
    'playfair display': {
        displayName: 'Playfair Display',
        fontFamily: 'playfair display',
        cdnName: 'PlayfairDisplay',
        genericFamily: 'serif',
        provider: 'google',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        fallbacks: '',
        spriteIndex: 107,
        supportedInHtmlEmails: true,
        key: 'playfair display',
        cssFontFamily: '"playfair display",serif',
        normalizedCss: 'playfairdisplay,serif',
    },
    'playfair display sc': {
        displayName: 'Playfair Display SC',
        fontFamily: 'playfair display sc',
        cdnName: 'PlayfairDisplaySC',
        genericFamily: 'serif',
        provider: 'google',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        fallbacks: '',
        spriteIndex: 108,
        supportedInHtmlEmails: true,
        key: 'playfair display sc',
        cssFontFamily: '"playfair display sc",serif',
        normalizedCss: 'playfairdisplaysc,serif',
    },
    pompiere: {
        displayName: 'Pompiere',
        fontFamily: 'pompiere',
        cdnName: 'Pompiere',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: [
            'latin',
            'latin-ext',
            'cyrillic',
            'cyrillic-ext',
            'greek',
            'greek-ext',
            'vietnamese',
        ],
        fallbacks: '',
        spriteIndex: 111,
        supportedInHtmlEmails: true,
        key: 'pompiere',
        cssFontFamily: 'pompiere,cursive',
        normalizedCss: 'pompiere,cursive',
    },
    raleway: {
        displayName: 'Raleway',
        fontFamily: 'raleway',
        cdnName: 'Raleway',
        genericFamily: 'sans-serif',
        provider: 'google',
        characterSets: ['latin', 'latin-ext', 'cyrillic'],
        fallbacks: '',
        spriteIndex: 110,
        supportedInHtmlEmails: true,
        key: 'raleway',
        cssFontFamily: 'raleway,sans-serif',
        normalizedCss: 'raleway,sans-serif',
    },
    Righteous: {
        displayName: 'Righteous',
        fontFamily: 'Righteous',
        cdnName: 'Righteous',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin', 'latin-ext'],
        fallbacks: '',
        spriteIndex: 128,
        supportedInHtmlEmails: true,
        key: 'Righteous',
        cssFontFamily: 'Righteous,cursive',
        normalizedCss: 'righteous,cursive',
    },
    roboto: {
        displayName: 'Roboto',
        fontFamily: 'roboto',
        cdnName: 'Roboto',
        genericFamily: 'sans-serif',
        provider: 'system',
        characterSets: ['latin', 'latin-ext'],
        fallbacks: 'arial',
        spriteIndex: 106,
        supportedInHtmlEmails: true,
        key: 'roboto',
        cssFontFamily: 'roboto,arial,sans-serif',
        normalizedCss: 'roboto,arial,sans-serif',
    },
    Rochester: {
        displayName: 'Rochester',
        fontFamily: 'Rochester',
        cdnName: 'Rochester',
        genericFamily: 'cursive',
        provider: 'google',
        characterSets: ['latin'],
        fallbacks: '',
        spriteIndex: 127,
        supportedInHtmlEmails: true,
        key: 'Rochester',
        cssFontFamily: 'Rochester,cursive',
        normalizedCss: 'rochester,cursive',
    },
    'titillium web': {
        displayName: 'Titillium Web',
        fontFamily: 'titillium web',
        cdnName: 'TitilliumWeb',
        genericFamily: 'sans-serif',
        provider: 'google',
        characterSets: ['latin', 'latin-ext'],
        fallbacks: '',
        spriteIndex: 122,
        supportedInHtmlEmails: true,
        key: 'titillium web',
        cssFontFamily: '"titillium web",sans-serif',
        normalizedCss: 'titilliumweb,sans-serif',
    },
};
export const FONTS = {
    ...WEB_SAFE_FONTS,
    ...CUSTOM_FONTS,
};
//# sourceMappingURL=fonts.js.map